import * as RadixSelect from '@radix-ui/react-select'
import { Check, ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'

// Drop-in for the console's ~20 short fixed-option native <select>s — same consistent popover
// across every browser, keyboard nav included, styled with the shared .field look.
export function Select({ value, onValueChange, placeholder, children, className }: {
  value: string
  onValueChange: (value: string) => void
  placeholder?: string
  children: ReactNode
  className?: string
}) {
  return (
    <RadixSelect.Root value={value || undefined} onValueChange={onValueChange}>
      <RadixSelect.Trigger className={`field flex items-center justify-between gap-2 bg-white text-left data-[placeholder]:text-gray-400 ${className ?? ''}`}>
        <RadixSelect.Value placeholder={placeholder} />
        <RadixSelect.Icon>
          <ChevronDown size={20} className="text-gray-500 shrink-0" />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>
      <RadixSelect.Portal>
        <RadixSelect.Content
          position="popper"
          sideOffset={8}
          className="z-[100000] w-[var(--radix-select-trigger-width)] overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-theme-lg"
        >
          <RadixSelect.Viewport className="p-2 max-h-72 overflow-y-auto custom-scrollbar">
            {children}
          </RadixSelect.Viewport>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  )
}

export function SelectItem({ value, children }: { value: string; children: ReactNode }) {
  return (
    <RadixSelect.Item
      value={value}
      className="relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 cursor-pointer select-none outline-none data-[highlighted]:bg-gray-100 data-[state=checked]:bg-brand-50 data-[state=checked]:text-brand-500"
    >
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
      <RadixSelect.ItemIndicator className="ml-auto">
        <Check size={16} className="text-brand-500" />
      </RadixSelect.ItemIndicator>
    </RadixSelect.Item>
  )
}
